import { Route, Routes } from 'react-router-dom';
import { useMount } from 'react-use';

import { getAllQueues } from 'components/settings/actions/queues';
import { useAppDispatch } from 'utils/redux/useAppDispatch';

import { SettingsMessagingView } from './settingsMessaging.view';
import { SettingsMessagingWhatsAppSetupView } from './views/whatsAppSetup';

const SettingsMessagingRoutes = () => {
  const dispatch = useAppDispatch();

  useMount(() => {
    dispatch(getAllQueues());
  });

  return (
    <Routes>
      <Route index element={<SettingsMessagingView />} />
      <Route
        path="whatsapp/setup"
        element={<SettingsMessagingWhatsAppSetupView />}
      />
    </Routes>
  );
};

/** The messaging settings routes of the application. */
export const settingsMessagingRoutes = (
  <Route path="messaging/*" element={<SettingsMessagingRoutes />} />
);
